

import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {Observable} from "rxjs";
import {UsageRecord} from "./usage-record.component";
import {Profile} from "../profile/profile.model";
import {MessageComponent} from "./message.component";

@Injectable()

export class UsageService {
    result: Object;
    error: Object;
    token: string;
    user_id: string;
    password: string;
    
    constructor(public http: HttpClient) {
        this.token = localStorage.getItem('token');
        this.password = localStorage.getItem('password');
        this.user_id = localStorage.getItem('user_id');       
    }
    
    getResultsCount(token, password):Observable<UsageRecord> {//have to pass in token and password as this object looses references when moving around app
        
        console.log('results count call initiated');
        let authToken = token + ':' + password;
        console.log("Home service getResultsCount authToken: " + authToken);
        const authOptions = {headers: new HttpHeaders({'Authorization': 'Bearer ' + authToken})};
        return this.http.get<UsageRecord>('/api/usage/', authOptions)
    }

    getUrl():Observable<Profile> {
        let authToken = this.token + ':' + this.password;
        console.log("Home service getUrl authToken: " + authToken);
        const authOptions = {headers: new HttpHeaders({'Authorization': 'Bearer ' + authToken})};
        return this.http.get<Profile>('/api/get-url/', authOptions)
    }

    getTSIPassword():Observable<Profile> {
        let authToken = this.token + ':' + this.password;
        const authOptions = {headers: new HttpHeaders({'Authorization': 'Bearer ' + authToken})};
        return this.http.get<Profile>('/api/get-tsi-password/', authOptions)
    }

    getAlerts():Observable<MessageComponent[]> {
        let authToken = this.token + ':' + this.password;
        const authOptions = {headers: new HttpHeaders({'Authorization': 'Bearer ' + authToken})};
         return this.http.get<MessageComponent[]>('/api/get-alerts/', authOptions)
     }
     getUpdates():Observable<MessageComponent[]> {
         let authToken = this.token + ':' + this.password;
         const authOptions = {headers: new HttpHeaders({'Authorization': 'Bearer ' + authToken})};
         return this.http.get<MessageComponent[]>('/api/get-updates/', authOptions)
     }

}
